var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgNextArrow = function SvgNextArrow(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 17,
    viewBox: "0 0 37 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 427321013"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M34.7186 7.36108C35.6111 7.36108 36.3345 8.08457 36.3345 8.97704C36.3345 9.8695 35.6111 10.593 34.7186 10.593L2.38673 10.593C1.49427 10.593 0.770798 9.8695 0.770798 8.97704C0.770798 8.08457 1.49427 7.36108 2.38673 7.36108L34.7186 7.36108Z",
    fill: "#2555EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-22",
    d: "M32.4354 8.97673L27.865 4.40604C27.2339 3.77496 27.2339 2.75178 27.865 2.1207C28.496 1.48962 29.5191 1.48962 30.1502 2.1207L35.8633 7.83406C36.4943 8.46514 36.4943 9.48832 35.8633 10.1194L30.1502 15.8328C29.5191 16.4638 28.496 16.4638 27.865 15.8328C27.2339 15.2017 27.2339 14.1785 27.865 13.5474L32.4354 8.97673Z",
    fill: "#2555EF"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNextArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/NextArrow.dfeccf00.svg";
export { ForwardRef as ReactComponent };